export const PRIVACY_POLICIES = [
	{
		name: 'Collection of personal Data',
		list: [
			`Bouk collects your personal data such as mobile number and email address to enable
      Bouk to send you a one-time password (OTP) during sign up and password reset.`,
			`Bouk and Bouk’s partners collect and process personal data for the purpose of
      connecting customers with merchants and carriers (boukers) to help them move
      around cities to make delivery pick-ups or drop-off more efficient and swifter.`,
			`To facilitate efficient delivery pick-up and drop-off, the Bouk application (App)
      provides Geo-location data and the phone number(s) of customers to drivers. When
      the Bouk app is activated, geo-location data is collected. After quitting or exiting
      the Bouk app, the collection of Geo-location data comes to an end.`,
			`Bouk and its partners use contact details to notify customers or merchants of updates
      to the Bouk app.`,
			`Bouk and its partners may use Geo-location data to resolve quality issues related to
      delivery pick-up and drop-off services.`,
			`We collect data on drivers (boukers) routes and customers location in order to
      critically analyze geographic coverage and make recommendations to drivers
      (boukers) about the most viable routes.`,
			`We obtain payment details to process customers' payment on behalf of the delivery
      pick-up and drop-off services.`,
			`Users/Customers names, phone numbers, e-mail, and any other information that
      Users/Customers voluntarily provide to us will be used to communicate with the
      Users/Customers and for other purposes related with the usage of Bouk app and its
      related services.`,
			`In connection with participation in our Referral Program, Bouk Users may not
      distribute, publish, or send any misleading, false, or deceptive communications.
      Such conduct may be in violation of various applicable laws. Bouk users may not
      send any referral emails, SMS messages, or other communications to children under
      the age of 13. Bouk Users are completely advised to adhere to this policy.`,
			`Customer support data is taken and retained on a case-by-case basis in order to
      resolve disputes and issues with service quality.`,
		],
	},
	{
		name: `Legal grounds on which your Personal data may be collected.`,
		list: [
			`Personal data is processed in order to deliver the service that consumers have
      requested. During the installation and use of the Bouk app, we gather, and process
      personal data provided by users. Customers/Users must agree to the processing of
      their identification, receiving of one-time password (OTP) and geo-location data
      before using Bouk services.`,
			`Personal data may also be processed in the course of legitimate business interests,
      such as monitoring and investigating fraudulent transactions.`,
		],
	},
	{
		name: `Your personal data we may collect`,
		list: [
			`Name, phone number, e-mail address, postal or delivery address, account name,
      signature, or other similar identifiers.`,
			`Bouk may collect face photo, identity document, facial recognition, voice, or other
      biometric data. Any biometric information will be permanently deleted from the
      system after it is no longer necessary.`,
			`We may collect your age, year, or date of birth to enable us, for example, to
      determine if you are eligible to make purchases of alcohol.`,
			`When you place an order using our services as a Bouk User, we collect information
      about that order. This could include information like the things you bought, special
      instructions, the date and time of your order, the subtotal, images you provide to
      Bouk, or other shopping habits or histories.`,
			`Geo-location of the User/Customer, the time, and the destination of a delivery pick-
      up or drop-off. General location Information (such as IP address) may be collected
      when you make use of our services. We may record and store the exact location of
      your gadget when the Bouk app is active in the forefront or backdrop of your mobile
      device or any other device if you authorize the services to use location services
      through the permission mechanism employed by your mobile operating system or
      browser. This information may be used to help you select your delivery address, to
      provide more accurate and precise deliveries of your orders, to provide
      recommendations to you, and to enhance your user experience and improve the
      services of Bouk. You can willingly choose to enable location tracking through your
      device's settings or when the Bouk mobile app prompts you to do so. If you
      deactivate the location feature on your device, the Bouker will not receive accurate
      location details from your mobile, which may limit delivery accuracy in some
      instances, such as if you are in a big area, such as a park.`,
			`Bouk also gathers technical details about your activities on our webpage, such as
      information about your browser and operating system, IP address (your computer's
      Internet address), individual and online identifiers, and other information like the
      app version you're using.`,
			`We use cookies to gather data about your interests in order to make your usage of
      the website more productive.`,
			`Bouk collects payment information such as bank name, payment method, or other
      financial information. We use a payment processor that collects your payment
      information and processes payments made on or through the Services. Our payment
      processor provides us with limited information about your credit or debit card, such
      as the last four numbers and the expiry date.`,
			`Bouk allows users to send gifts using the services and invite friends and family to
      sign up for our Services. When a friend or family member signs up and places a
      purchase or makes a pick-up or drop-off request using your referral link, we may
      give a promotional value. To help you do this, we may request you to grant us access
      to your mobile device address book. You can then direct us to send referral emails
      to contacts you select in your address book.

      By sending a referral or gift, you consent to Bouk sending your public profile image
      to the contacts you select to receive a referral link or gift. By choosing to invite a
      friend or sending a gift to a recipient, you represent that you have received the
      friend’s and/or recipient’s consent to provide his or her name, mailing address,
      email address or other information with us. Bouk will use that information to send
      the requested gift or an email urging him or her to visit the webpage, as well as to
      track the referral program's success and possibly send marketing emails. You can
      also send an SMS with a referral link to your contacts. If you use this option, you
      understand that Bouk does not control the timing, content, or recipients of these
      SMS messages you sent.
      `,
			`If you are referred to Bouk through one of our referral programs, or if someone
      attempts to refer you, we may share your name, whether you have already signed
      up for Bouk, whether you are a new customer, and whether you have placed a
      qualifying order with Bouk with the person(s) who referred you.`,
		],
	},
	{
		name: `Security and access of your personal data`,
		list: [
			`Any personal data gathered during the provision of services is transmitted to and
      saved in the Amazon Web Services, Inc. data center, which is based in the United
      States of America and territories of European Union Member States. Only
      authorized employees and partners of Bouk LLC have access to user information,
      and they may strictly only use it to resolve issues related to the usage of the services
      (including disputes regarding transportation services). Bouk has put in place
      necessary technical and organizational safeguards to protect personal data from
      unintended, unauthorized, or unlawful loss, modification, exploitation, theft,
      exposure, or entry, as well as all other types of unlawful processing.`,
			`Personal data can be accessed by Bouk LLC and its partners to the extent necessary
      to provide customer service in the particular country.`,
			`Geolocation data is only handled in an anonymized and individualized form if it is
      required to be linked to a customer in order to resolve disputes or fraud.`,
			`The information is used in an unidentifiable form for research and scientific
      applications (anonymized).`,
		],
	},
	{
		name: `Recipients of your personal data we may collect`,
		list: [
			`After providing the delivery pick-up or drop-off service, the name and the telephone
      number of the customer will remain visible to the carrier (bouker or merchant) for
      24 hours. This is required for carriers (Bouker or merchant) to resolve any service-
      related difficulties, such as contacting the user if something was forgotten.`,
			`Customers' personal data is only shared with drivers (Bouker or merchants) who
      have enabled the Bouk app; in this case, the driver (Bouker or merchant) will see
      the customer's name, phone number, and geo-location data.`,
			`Depending on the user's location, personal information may be shared to Bouk LLC
      and partners (local subsidiaries, representatives, affiliates, agents, etc.). Personal
      data will be processed by Bouk LLC and its partners under the same terms as set
      forth in this privacy notice.`,
			`Customers' feedback on the quality of service is anonymous, and drivers (boukers
        or merchants) are not given the names or phone numbers of users who offered
        ratings and comments.`,
		],
	},
	{
		name: `Retention of your personal data`,
		list: [
			`Customers' personal information will be kept for as long as they have an active
      user profile. Personal data shall be erased (in line with the policies set forth herein)
      from servers after a user's account is deleted, unless such information is necessary
      to be preserved for financial reporting, grievance redressal, or fraud prevention
      purposes.`,
			`Financial information on customers' delivery pick-up or drop-off services will be
      kept for two years after the last delivery pick-up or drop-off. Accounting data will
      be kept for a period of eight years (after the last delivery or pick-up).`,
			`The data will be kept for 11 years if there are indications of a criminal offense, fraud,
      or deceptive information being submitted.`,
			`In the event of a payment dispute, data will be kept until the case is resolved or until
      the claim's expiration date. Data about delivery pick-up or drop-off history will be
      kept for three years and one month before being erased. In the event of a payment
      dispute, data will be kept until the case is resolved or until the claim's expiration
      date. Data about delivery pick-up or drop-off history will be kept for three years and
      one month before being erased.`,
			`Please be aware that removing the Bouk app from your smartphone does not result
      in the erasure of your personal information.`,
			`If you haven't used the Bouk app in three years, we'll alert you and ask you to affirm
      that your account is still functional. If you acknowledge that the profile is dormant
      or if we do not receive a response, the account will be terminated, and personal data
      will be removed unless it is required to be kept for the purposes of this agreement.`,
		],
	},
	{
		name: `Access and correction`,
		list: [
			`The Bouk app allows you to view and update your name, phone number, and e-mail
      address.`,
			`Personal data can also be viewed and corrected by sending a request notice to
      Bouk support.`,
		],
	},
	{
		name: 'Account Deletion',
		description: `At Bouk, we prioritize the privacy and control of our users' personal information. As part
    of our commitment to transparency and user empowerment, we offer a comprehensive
    account deletion process. Users are provided with the option to request the deletion of their
    account, ensuring their ability to manage their data effectively. Below is an outline of our
    account deletion policy:`,
		list: [
			`Within the App: Users will find a clearly identifiable option within the app interface
      to initiate the deletion of their account. This option is easily accessible and ensures
      a seamless experience for users wishing to remove their account from the app.`,
			`Outside the App: Users can also initiate the account deletion process by visiting our
      website. We ensure that the process for requesting account deletion is easily
      accessible and clearly outlined on our website, providing users with flexibility in
      managing their accounts.`,
			`Data Removal: Upon receiving a request for account deletion, we are committed to
      promptly removing all associated user data from our systems. This includes any
      personal information or user-generated content that may be stored in our databases.`,
			`Data Retention for Legitimate Reasons: In certain circumstances, we may need to
      retain certain user data for legitimate reasons such as security, fraud prevention, or
      regulatory compliance. In such cases, we adhere to the following guidelines:
     
   
      1: If there is suspicion of an administrative or criminal offense, forgery, or
      incorrect information, the data will be kept for a period of 11 years.
  
      2: Data required for accounting records will be retained for a period of eight years.
   
      3: In situations of conflict, the data must be kept until the claim is resolved or until
      the expiration date of the claim.
    
      
      `,
			`All personal information, including account details for requests carried out, previous

      requests, pending requests, and pending payments, will be deleted and non-
      retrievable for future purposes. By deleting your account, you agree to the forfeiture
      
      of future or pending payments and requests. Consequently, a Customer/User who
      has had their account deleted will not be able to utilize the Bouk app.`,
			`Customer service is used to resolve disputes over the processing of personal data.`,
		],
	},
	{
		name: 'Direct marketing',
		list: [
			`We and our partners will only directly send marketing communications to your e-
      mail address and/or phone number if you have granted us authorization to do so via
      the Bouk website or the Bouk app. We may tailor direct marketing messages to you
      based on how you use Bouk services (frequency of use, delivery pick-ups, drop-
      offs, payments).`,
			`Please click the "Unsubscribe" link in the footer of our emails or in the profile
      section of the Bouk app if you no longer want to receive direct marketing messages.`,
		],
	},
	{
		name: 'Portability',
		list: [
			`Within a month, we shall respond to any e-mail request for personal data transfer
      and state when the data will be transferred. We will supply you with your personal
      data, which includes contact details, delivery pick-up or drop-off record for the
      previous three years, and transaction details, after we have verified the user in
      question.`,
		],
	},
	{
		name: 'Restricted Areas',
		list: [
			`Intending Customers/Users who reside in California and the European Economic
      Area are presently not eligible to utilize Bouk platforms and services. You accept
      to only use Bouk Platforms and Services in the areas/regions/states/locations where
      Bouk operates. If you live in California or the European Economic Area ("EEA"),
      please, kindly do not download/use/access the Bouk Platform or Services, neither
      should you give nor enable Bouk receive personal information from you a California
      resident or EEA citizen.`,
		],
	},
];

export const POLICIES_SECTIONS = [
	{
		name: 'SECTION A',
		title: 'DEFINITIONS.',
		list: [
			`Personal Data - This is information about a recognized or known individual that is
      utilized to determine or track that person (a natural person's identity), either alone or in
      combination with additional personal or distinguishing data that is connected or
      associated to that person. Personal Data also includes any additional data about a precise
      individual that is defined as Personal Data by the data protection rules prevalent in the
      jurisdictions where that person resides.`,
			`Process or Processing - The recording, utilization, accessibility to, publication, storing,
      transmission, or other handling of Personal Data of any private citizen that the discloser
      permits to use or access a service is referred to as this.`,
			`Systems - means a Party’s computer systems or network (including third-party systems
        such as Amazon Web Services) that host, process or store the Discloser’s Personal Data.`,

			`Privacy and Security Laws - This refers to U.S. federal, state, and municipal
      regulations, as well as non-U.S. laws, that govern the safety and confidentiality of Personal
      Data and are applicable to Bouk and/or Merchant, as the case may be.`,
			`Security Incident - This refers to illegal accessibility to or collection of Personal Data
      held on User's devices, resulting in the breach of Personal Data for which Discloser is
      liable.`,
		],
	},
	{
		name: 'SECTION B',
		title: `PROCESSING PERSONAL DATA.`,
		list: [
			`Personal Data can be obtained and then used to send one-time password (OTP) for sign-
      up, deliver, assist, and optimize the Services, enforce the Contract and further the
      
      Merchant-Bouk business relationship, adhere to rules, and act in conformity with the
      Discloser's written instructions or otherwise in compliance with the Agreement Terms
      during the provision and use of the Offerings. Discloser gives Recipient right to obtain,
      utilize, retain, and transmit Personal Data for the exclusive purpose of delivering or
      administering the services.`,
			`Upon becoming aware of any confirmed unauthorized or unlawful breach of security
      that leads to the destruction, loss, alteration, or unauthorized disclosure of or access to
      Discloser Personal Data, Recipient shall notify Discloser.`,
		],
	},
	{
		name: 'SECTION C',
		title: `COMPLIANCE WITH PRIVACY AND INFORMATION SECURITY
    REQUIREMENTS.`,
		list: [
			`If relevant, the recipient must adhere to all applicable privacy and confidentiality laws,
      as well as the EU-US Privacy Shield Framework established by the US Department of
      Commerce for the capture, utilization, and storage of Personal Data from the European
      Economic Area. In addition, Recipient must adhere to the United States-Swiss Safe Harbor
      framework, or its alternative, as laid forth by the United States Department of Commerce
      for the acquisition, processing, and storage of Personal Data from Switzerland, if
      applicable. The CCPA and TCPA are examples of privacy and security laws.`,
			`Recipient shall ensure appropriate technical and organizational security measures
      directly correlated with the sensitivity of the Personal Data processed on Discloser's behalf,
      which are intended to shield the safety, trustworthiness, and privacy of such Personal Data,
      as well as prevent unauthorized or malicious destruction, damage, modification, and
      unauthorized disclosure or access.`,
			`Access; Contacts - Only Members who have a cogent reason to access Personal Data in
      order to offer, support, and enhance the Products and Services shall have access to Personal
      Data.`,
		],
	},
	{
		name: 'SECTION D',
		title: `RESPONSE TO SECURITY INCIDENT`,
		description: `Recipient shall, In the event Recipient discovers a Security incident;`,
		list: [
			`Notify discloser of the discovery of the security Incident. Such notice shall summarize
      the known circumstances of the Security Incident and the corrective action taken or to be
      taken by Recipient.`,
			`Conduct an investigation of the circumstances of the Security Incident.`,
			`Use commercially reasonable efforts to remediate the Security Incident.`,
			`Use commercially reasonable efforts to communicate and cooperate with Discloser
      concerning its response to the Security Incident.`,
			`Allow Discloser to run a security audit to assess whether the Security Incident has been
      resolved at Recipient’s sole expense.`,
		],
	},
	{
		name: 'SECTION E',
		title: `DISCLOSER OBLIGATIONS.`,
		description: `Discloser acknowledges that it has a legal basis for allowing Recipient to process Personal
    Data, and/or that Discloser has made such disclosures and acquired such permit and
    approvals for Recipient to lawfully treat Personal Data.`,
	},
	{
		name: 'SECTION F',
		title: `RESTRICTED AREAS.`,
		description: `Intending Merchants/Sellers who reside in California and the European Economic Area are
    presently not eligible to utilize Bouk platforms and services. You accept to only use Bouk
    Platforms and Services in the areas/regions/states/locations where Bouk operates. If you
    live in California or the European Economic Area ("EEA"), please, kindly do not
    download/use/access the Bouk Platform or Services, neither should you give nor enable
    Bouk receive personal information from you a California resident or EEA citizen.`,
	},
];
